import { HeadTitleContent } from '../../../commons/Constants';
// import LoginPage from '../../../components/mui5/login/login';
import dynamic from 'next/dynamic';
import { Backdrop } from '../../../components/global';

const LoginPage = dynamic(
  () => import('../../../components/mui5/login/login'),
  { ssr: false, loading: () => <Backdrop manual={true} /> }
);

export default function Login() {
  return <LoginPage />;
}
export async function getServerSideProps(context) {
  return {
    props: {
      extraMeta: {
        title: HeadTitleContent['login'].title,
        description: HeadTitleContent['login'].description,
      },
    },
  };
}
